import React from "react";
import PropTypes from "prop-types";
import { Box } from "@common/components/";
import { ScrollableTable, ProductInfo } from '@curves/ui-shared';

const headerRow = [
	{
		cellKey: "product",
		headerLabel: "商品清單",
		minWidth: 280,
		formatCell: (_, row) => (
			<ProductInfo
				product={{
					sku: row.sku ?? row.productCode,
					name: row.productName ?? row.name,
					spec: row.spec ?? "",
				}}
			/>
		),
	},
	{
		cellKey: "quantity",
		headerLabel: "數量",
		align: "center",
		minWidth: 100,
	},
];

/**
 * 出貨單 - 商品清單 Tab 內容
 * 欄位：商品資訊(ProductInfo)、數量
 */
const ShipmentProductList = ({ products = [], className }) => {
	return (
		<Box className={className}>
			<ScrollableTable
				headerRow={headerRow}
				rowsData={products}
				rowKey="productID"
				tableClassName="theme-gray"
			/>
		</Box>
	);
};

ShipmentProductList.propTypes = {
	products: PropTypes.arrayOf(
		PropTypes.shape({
			productID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			sku: PropTypes.string,
			productCode: PropTypes.string,
			productName: PropTypes.string,
			name: PropTypes.string,
			spec: PropTypes.string,
			quantity: PropTypes.number,
		})
	),
	className: PropTypes.string,
};

export default ShipmentProductList;
